__turbopack_context__.v({
  "anchor": "listenOptions-module-scss-module__k6iFZq__anchor",
  "options": "listenOptions-module-scss-module__k6iFZq__options",
  "popover": "listenOptions-module-scss-module__k6iFZq__popover",
  "sizedToAnchor": "listenOptions-module-scss-module__k6iFZq__sizedToAnchor",
});
